import { runSafe } from "../utils";

export function initDataClickSources(element: Element): void {
  runSafe(() => {
    for (const clickSource of element.querySelectorAll<HTMLElement>("[data-click-source]")) {
      initDataClickSource(clickSource);
    }
  })
}

export function initDataClickSource(clickSource: HTMLElement) {
  const target = clickSource.querySelector<HTMLAnchorElement>("[data-click-target]");

  if (!target) {
    return;
  }

  const anchor = target;

  clickSource.addEventListener("click", handleSourceClick);
  clickSource.addEventListener("pointerdown", handleSourcePointerDown);
  clickSource.addEventListener("pointerup", handleSourcePointerUp);

  function handleSourceClick(e: MouseEvent) {
    if (!shouldInterceptClick(e)) {
      return;
    }

    if (e.ctrlKey) {
      openAnchorUrlInNewTab(e, anchor);
    } else {
      anchor.click();
    }
  }

  function handleSourcePointerDown(e: PointerEvent) {
    if (shouldInterceptClick(e)) {
      e.preventDefault();
    }
  }

  function handleSourcePointerUp(e: PointerEvent) {
    if (!shouldInterceptClick(e)) {
      return;
    }

    if (e.button === 1) {
      openAnchorUrlInNewTab(e, anchor);
    }
  }
}

function openAnchorUrlInNewTab(e: MouseEvent, anchor: HTMLAnchorElement): void {
  e.preventDefault();

  const event = new MouseEvent("click", { ctrlKey: true, metaKey: true })
  anchor.dispatchEvent(event);
}

function shouldInterceptClick(e: MouseEvent): boolean {
  const eventTarget = e.target;

  return !(eventTarget instanceof HTMLButtonElement || eventTarget instanceof HTMLAnchorElement);
}